import { AppConfig } from '../../../app/shared/app-config/app-config.model'
import { defaultAppConfig } from '../../../app/shared/app-config/app-config-default'

export const appConfig: AppConfig = {
  ...defaultAppConfig,
  core: {
    ...defaultAppConfig.core,
    recaptcha: { ...defaultAppConfig.core.recaptcha, siteKey: '6LfgApoUAAAAABr6a3oF89UDwZ19AH7JIltamTKs' },
    documentTitle: 'Autoguidovie Account',
    brandName: 'Autoguidovie',
    clientName: 'pw-agi',
    cardLayoutLogo: {
      default: {
        height: 90,
        width: 250,
      },
    },
    termsAndConditionsVisible: false,
    helplineNumber: '+39 800086567',
  },
  login: {
    ...defaultAppConfig.login,
    singleSignOn: {
      ...defaultAppConfig.login.singleSignOn,
      clientName: 'agiProfilazione',
    },
  },
  myCiceroWebApi: {
    ...defaultAppConfig.myCiceroWebApi,
    urls: {
      ...defaultAppConfig.myCiceroWebApi.urls,
      _base: 'https://www.mycicero.it/Net.Pluservice.Api.ProfilazioneWeb/api',
    },
  },
  signUp: {
    ...defaultAppConfig.signUp,
    form: {
      ...defaultAppConfig.signUp.form,
      fields: {
        ...defaultAppConfig.signUp.form.fields,
        dateOfBirth: {
          ...defaultAppConfig.signUp.form.fields.dateOfBirth,
          visible: true,
          required: true,
        },
        domicile: {
          ...defaultAppConfig.signUp.form.fields.domicile,
          visible: true,
          required: true,
        },
      },
      domicile: {
        ...defaultAppConfig.signUp.form.domicile,
        showHouseNumber: true,
      },
    },
  },
}
